import { buildTimeIntervalDimensionsConfig, createSchemaConfig } from '../helpers/schema.helpers'
import { InsightsFormatterType } from '../types/schema.types'
import { Metrics, Dimensions } from './insightsPortalImageCoverage.types'

export { Metrics, Dimensions }

export const schemaConfig = createSchemaConfig({
  metrics: Metrics,
  dimensions: Dimensions,
  metricsConfig: {
    [Metrics.IMAGE_COVERAGE]: {
      formatter: InsightsFormatterType.Percentage,
      label: 'insightsPortalDomain.searchDashboard.metrics.imageCoverage',
      tooltip: 'insightsPortalDomain.searchDashboard.tooltips.imageCoverage',
    },
  },
  dimensionsConfig: {
    ...buildTimeIntervalDimensionsConfig,
    [Dimensions.WAREHOUSE]: {
      label: 'insightsPortalDomain.filters.retailers.label',
    },
    [Dimensions.ZONE_STATE]: {
      label: 'insightsPortalDomain.dataExplorer.reportTable.header.warehouseLocationState',
    },
  },
})
